export type LabelType = {
  id: number;
  label: string;
  value: string | number;
};

export type DeploymentDataType = {
  id: number;
  device_id: number;
  area: string;
  outlet: string;
  property: string;
  customer: string;
  device_upload_count;
  oldest_unlabelled: string;
  data_validity: string;
  active: boolean;
  start_date: string;
  end_date: string;
  unfinished_count: number;
};

export type Props = {
  location: { state: undefined | any }; //TODO
  history: any;
};

export type FullLabelType = {
  avoidable: string;
  class: string;
  description: string;
  group: string;
  id: number;
  subgroup: string;
  transformed: string;
  untransformed: string;
  value: number;
};

export type TrasheventListType = {
  cons_conflict_checked_by;
  consensus_conflict: boolean;
  consensus_labels: Array<{
    id: number;
    labelled_by: number;
    transformed: boolean;
    username: string;
  }>;
  consensus_matched: boolean;
  datetime: string;
  device_id: number;
  final_errors: Array<number>;
  final_labelled_by: number;
  final_labels: Array<{
    id: number;
    percentage: number;
    transformed: boolean;
  }>;
  final_username: string;
  image_id: string;
  outlet_id: number;
  prev_image_id: string;
  trashevent_id: number;
  weight: number;
  on_cd: boolean;
  viable_for_cd: boolean;
};

export type LabellingModal = {
  trasheventData: TrasheventListType | null;
  title: string;
  imageURL: string | null;
  prevImageURL: string | null;
  isOpen: boolean;
};

export type FilteredTrasheventResponse = {
  trashevents: { [label: string]: TrasheventListType };
  has_more: boolean;
  next_cursor: number | null;
};

export type PaginationState = {
  hasMore: boolean;
  nextCursor: number | null;
  isLoadingMore: boolean;
};

export enum WeightPrefixEnum {
  EQUAL_TO = "equal to",
  ABOVE_OR_EQUAL_TO = "above or equal to",
  BELOW_OR_EQUAL_TO = "below or equal to",
  STRICTLY_ABOVE = "strictly above",
  STRICTLY_BELOW = "strictly below",
}

export type QueryParamsType = {
  deployment_id: number;
  weight: number;
  weight_prefix: WeightPrefixEnum;
  label_ids: Array<number>;
  labeller_ids: Array<number>;
  start_date: string | null;
  end_date: string | null;
};
